module.exports = __webpack_public_path__ + "static/media/eba_feb_2025.36c95186.webp";